import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { Checkbox, Divider, Select } from "antd";

import Actions from "../../redux/actions";
import Service from "../../service/mgt-permission";

const Container = styled.div`
  display: grid;

  display: flex;
  flex-direction: column;

  .group {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .group-title{
    font-size: 18px;
    font-weight: bold;
  }
  gap: 24px 0px;

  & > * {
    margin-left: 8px;
  }
  @media only screen and (max-width: 450px) {
    grid-template-columns: 1fr 1fr;
  }

  @media only screen and (min-width: 768px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

function GetTitle(key) {
  if (key === "mgt-org") return "จัดการหน่วยงาน/องค์กร";
  if (key === "mgt-user") return "จัดการผู้ใช้งานระบบ";
  if (key === "mgt-station") return "จัดการสถานี";
  if (key === "mgt-sensor") return "จัดการเซนเซอร์";
  if (key === "mgt-sensor-data") return "จัดการข้อมูลที่ได้รับจากเซนเซอร์";
  if (key === "mgt-parameter") return "จัดการพารามิเตอร์ของเซนเซอร์";
  if (key === "mgt-sensor-data-alarm")
    return "จัดการการแจ้งเตือนข้อมูลเซนเซอร์";
  return "";
}

export default function MgtPermission(props) {
  const dispatch = useDispatch();
  const [data, setData] = useState({});
  const [state, setState] = useState(null);

  useEffect(() => {
    // group by key module
    let _data = props.data.reduce((r, a) => {
      r[a.module] = [...(r[a.module] || []), a];
      return r;
    }, {});
    setData(_data);
  }, [props.data, dispatch]);

  const onTriggerPermission = async (e) => {
    let checked = e.target.checked;
    let permissionId = e.target.value;
    if (checked) {
      let result = await Service.add({
        groupId: props.groupId,
        permissionId: permissionId,
      });
      dispatch(Actions.MgtPermission.add(result));
    } else {
      let result = await Service.remove({
        groupId: props.groupId,
        permissionId: permissionId,
      });
      dispatch(Actions.MgtPermission.remove(result));
    }
  };

  return (
    <>
      <Divider />
      <Container>
        {Object.keys(data).map((key) => (
          <div className="group" key={key}>
            <div className="group-title">{GetTitle(key)}</div>
            <div className="group-content">
              {data[key].map((item) => (
                <Checkbox
                  key={item.permission_id}
                  value={item.permission_id}
                  onChange={onTriggerPermission}
                  checked={item.acc == 0 ? false : true}
                >
                  {item.title}
                </Checkbox>
              ))}
            </div>
          </div>
        ))}
        {/* {props.data.map((item) =>( <Checkbox key={item.permission_id} value={item.permission_id} onChange={onTriggerPermission} checked={item.acc == 0 ? false : true}>{item.title}</Checkbox>))} */}
      </Container>
    </>
  );
}
